<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d--flex justify-content--space-between align-items--center">
        <dara-header>{{ $t('users') }}</dara-header>
        <dara-button v-if="currentUser.permission > 1" @click="onCreateUser">
          {{ $t('add-user') }}
        </dara-button>
      </div>
      <div
        v-for="user in usersList"
        :key="user.id"
        class="mb--xl">
        <dara-user-card
          :user="user"
          :best-writer-id="bestWriter ? bestWriter.id : ''"
          :top-writer-id="topWriter ? topWriter.id : ''"
          :top-reader-id="topReader ? topReader.id : ''"
          @setDeleteUser="setDeleteUser($event)" />
      </div>
      <dara-modal-delete
        v-if="showModal()"
        :content="$t('are-you-sure-you-want-to-delete-this-user')"
        @close="setDeleteUser(null)"
        @confirm="onDeleteUser()">
      </dara-modal-delete>
      <dara-pagination
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="fetch" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToCreateUser } from '@/modules/user/user.routes';
import { fetchUsers, removeUser, fetchBestWriters, fetchTopReaders, fetchTopWriters } from '@/modules/user/user.service';
import { getters } from '@/modules/user/user.store';
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';

import DaraUserCard from '@/modules/user/components/UserCard.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraMySpaceUsers',
  components: {
    DaraUserCard,
    DaraSingleContentLayout,
  },
  data() {
    return {
      currentUser: getters.getUser(),
      usersList: [],
      deletedUser: null,
      pagination: {
        page: 1,
        limit: 5,
      },
      bestWriter: null,
      topWriter: null,
      topReader: null,
    };
  },
  mounted() {
    this.fetch();
    this.fetchFeaturedUsers();
  },
  methods: {
    fetchFeaturedUsers() {
      this.fetchBestWriter();
      this.fetchTopWriter();
      this.fetchTopReader();
    },
    fetchBestWriter() {
      fetchBestWriters(1)
        .then(user => {
          this.bestWriter = user;
        })
        .catch(() => {
          toastError(`${translate('error-getting-best-writer')}`);
          this.bestWriter = null;
        });
    },
    fetchTopWriter() {
      fetchTopWriters(1)
        .then(user => {
          this.topWriter = user;
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-writer')}`);
          this.topWriter = null;
        });
    },
    fetchTopReader() {
      fetchTopReaders(1)
        .then(user => {
          this.topReader = user;
        })
        .catch(() => {
          toastError(`${translate('error-getting-top-reader')}`);
          this.topReader = null;
        });
    },
    fetch() {
      this.usersList = [];
      fetchUsers(this.pagination)
        .then(data => {
          this.usersList = data.users;
          this.pagination.total = parseInt(data.total_company_users);
        })
        .catch(() => {
          this.usersList = [];
          toastError(`${translate('error-getting-users')}`);
        });
    },
    setDeleteUser(user) {
      this.deletedUser = user;
    },
    showModal() {
      return this.deletedUser;
    },
    onDeleteUser() {
      if (this.deletedUser) {
        removeUser(this.deletedUser).then(() => this.$router.go(0));
      }
    },
    onCreateUser() {
      goToCreateUser(this.$router);
    },
  },
};
</script>
